import { QueryClient } from '@tanstack/react-query';
import { AppError, errorTracker } from '@repo/shared/common';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: FIVE_MINUTES_MS,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        onError(error) {
          if (error instanceof AppError) return;
          errorTracker.captureException(
            error instanceof Error ? error : new Error(String(error)),
            { source: 'tanstack-query-mutation' },
          );
        },
      },
    },
  });
}
